import request from '@/utils/request'
import store from '@/store'

const url = store.getters.getPostUrl;
export default {
	getAllRole() {
		return request({
			url: url + '/cmm/role/all',
			method: 'get'
		})
	},
	getUserList(param) {
		return request({
			url: url + '/user',
			method: 'get',
			params: param
		})
	},
	getTimeList(param) {
		return request({
			url: url + '/time/page',
			method: 'get',
			params: param
		})
	},
	getAllUser(param) {
		return request({
			url: url + '/user/list',
			method: 'get',
			data: param
		})
	},
	addArea(data) {
		return request({
			url: url + '/area/add',
			method: 'post',
			data: data
		})
	},
	addUser(data) {
		return request({
			url: url + '/role/add',
			method: 'post',
			data: data
		})
	},
	addTime(data) {
		return request({
			url: url + '/time/add',
			method: 'post',
			params: data
		})
	},
	updataTime(data) {
		return request({
			url: url + '/time/update',
			method: 'put',
			params: data
		})
	},
	addNewUser(data) {
		return request({
			url: url + '/user',
			method: 'post',
			data: data
		})
	},
	updataNewUser(data, id) {
		return request({
			url: url + '/user/' + id,
			method: 'put',
			data: data
		})
	},
	addEquipment(data) {
		return request({
			url: url + '/device/add',
			method: 'post',
			data: data
		})
	},
	updataArea(data) {
		return request({
			url: url + '/area/update',
			method: 'put',
			data: data
		})
	},
	updataEquipment(data) {
		return request({
			url: url + '/device/update',
			method: 'put',
			data: data
		})
	},
	updataUser(data) {
		return request({
			url: url + '/role/update',
			method: 'put',
			data: data
		})
	},
	reset(id) {
		return request({
			url: url + '/cmm/user/password/' + id,
			method: 'get'
		})
	},
	delEquipment(id) {
		return request({
			url: url + '/device/delete',
			method: 'delete',
			data: id
		})
	},
	delArea(id) {
		return request({
			url: url + '/Area/delete',
			method: 'delete',
			data: id
		})
	},
	delTime(id) {
		return request({
			url: url + '/time/delete',
			method: 'delete',
			data: id
		})
	},
	delUser(id) {
		return request({
			url: url + '/role/delete',
			method: 'delete',
			data: id
		})
	},
	delNewUser(id) {
		return request({
			url: url + '/user',
			method: 'delete',
			data: id
		})
	},
	delCustomer(id) {
		return request({
			url: url + '/customer/delete',
			method: 'delete',
			data: id
		})
	},
	AddCustomer(data) {
		return request({
			url: url + '/customer/add',
			method: 'post',
			data: data
		})
	},

	UpdateCustomer(data) {
		return request({
			url: url + '/customer/update',
			method: 'put',
			data: data
		})
	},
	getAreaMesList(data) {
		return request({
			url: url + '/area/page',
			method: 'get',
			params: data
		})
	},
	getUserName(data) {
		return request({
			url: url + '/user/getUserByName',
			method: 'post',
			data: data
		})
	},
	getCustomerPage(data) {
		return request({
			url: url + '/customer/page',
			method: 'get',
			params: data
		})
	},
	getCustomerList(data) {
		return request({
			url: url + '/customer/list',
			method: 'get',
			params: data
		})
	},
	getBaseDeviceList() {
		return request({
			url: url + '/device/list',
			method: 'get',
		})
	},
	getRoleList1() {
		return request({
			url: url + '/role/list',
			method: 'get',
		})
	},
	getRoleList(data) {
		return request({
			url: url + '/role/page',
			method: 'get',
			params: data
		})
	},
	getAdressList(data) {
		return request({
			url: url + '/area/list',
			method: 'get',
			params: data
		})
	},
	getDictionaryList(data) {
		return request({
			url: url + '/business/dict/dictName',
			method: 'get',
			params: data
		})
	},
	getDictionaryMes(data, id) {
		return request({
			url: url + '/business/dict/dictContent/' + id,
			method: 'get',
			params: data
		})
	},
	AddDictionary(data) {
		return request({
			url: url + '/business/dict/dictName',
			method: 'post',
			data: data
		})
	},
	AddDictionaryMes(data) {
		return request({
			url: url + '/business/dict/dictContent',
			method: 'post',
			data: data
		})
	},
	UpdateDictionaryMes(data) {
		return request({
			url: url + '/business/dict/dictContent',
			method: 'put',
			data: data
		})
	},
	UpdateDictionary(data) {
		return request({
			url: url + '/business/dict/dictName',
			method: 'put',
			data: data
		})
	},
	deleteDictionary(data) {
		return request({
			url: url + '/business/dict/dictName',
			method: 'delete',
			data: data
		})
	},
	deleteDictionaryMes(data) {
		return request({
			url: url + '/business/dict/dictContent',
			method: 'delete',
			data: data
		})
	},
	getDeviceList(data) {
		return request({
			url: url + '/device/page',
			method: 'get',
			params: data
		})
	},
	getDeviceType() {
		return request({
			url: url + '/device/getDeviceType',
			method: 'get',
			params: ''
		})
	},
	getMenusByRoleLevel(data) {
		return request({
			url: url + '/role/getMenusByRoleLevel',
			method: 'get',
			params: data
		})
	},
	getContomerAllList() {
		return request({
			url: url + '/customer/getContomerList',
			method: 'get',
		})
	},
	getChooseCustomerList(data) {
		return request({
			url: url + '/customer/getChooseCustomerList',
			method: 'post',
			data: data
		})
	},

	updateUserCustomerRelation(data) {
		return request({
			url: url + '/customer/updateUserCustomerRelation',
			method: 'post',
			data: data
		})
	},

	AddUserArea(data) {
		return request({
			url: url + '/userArea/add',
			method: 'post',
			data: data
		})
	},

	geteqMonitor(customerId) {
		console.log("customerId" + customerId);
		return request({
			url: url + '/device/deviceInfo?customerId=' + customerId,
			method: 'get'
		})
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/system/user.js